import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import styled from 'styled-components'; // eslint-disable-next-line prefer-arrow-callback

var VisuallyHidden = styled(function VisuallyHiddenElement(_ref) {
  var _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'span' : _ref$component,
      props = _objectWithoutProperties(_ref, ["component"]);

  return React.createElement(Component, props);
}).withConfig({
  displayName: "VisuallyHidden",
  componentId: "sc-1hxtx7m-0"
})(["border:0;clip:rect(0,0,0,0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;"]);
export default VisuallyHidden;